import { breakpointLargeHandset } from '@pocket/web-ui';
import { breakpointTinyTablet } from '@pocket/web-ui';
import { css } from 'linaria'; // Adding this so we can compose within `css`

export const cardsGrid = {
  display: 'grid',
  alignItems: 'start',
  justifyContent: 'space-between',
  gridColumnGap: 'var(--spacing150)',
  gridRowGap: 'var(--spacing150)',

  /* this is a 12 column grid */
  gridTemplateColumns: 'repeat(12, 1fr)',
  gridAutoFlow: 'dense',
  [breakpointLargeHandset]: {
    gridColumnGap: 'var(--spacing100)',
    gridRowGap: 'var(--spacing100)'
  }
};
export const cardGrid = "c1gz9fnf";
export const cardsContainer = "cmg9k0j";

require("./base.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./base.js");